import { on, reducer } from "ts-action";

import { loadParteiSicht } from "./parteien-actions.js";
import type { ParteiSichtErgebnis } from "../service/parteien-service.js";

export interface ParteienState {
  /** Trägt `fuer` — wer schnell wechselt, sieht kurz die vorige; die Seite prüft. */
  sicht?: ParteiSichtErgebnis;
}

const initialState: ParteienState = {};

export const parteienReducer = reducer<ParteienState>(
  initialState,
  on(loadParteiSicht.success, (state, { payload }) => ({ ...state, sicht: payload })),
);
